export default __webpack_public_path__ + "static/media/07-BismuthDonut.171a0d32.png";